"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictSettingsSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class DistrictSettingsSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            curriculum: data.curriculum,
            type: data.type,
            districtId: data.districtId,
            options: data.options,
        };
    }
}
exports.DistrictSettingsSerializer = DistrictSettingsSerializer;
//# sourceMappingURL=district-settings.serializer.js.map